import {
    ModalLayout,
    Pagination,
    SearchFilters,
    Table,
  } from "@wac-ui-dashboard/wac_component_library";
  import React from "react";
  import { FaSort } from "react-icons/fa";
  import EmptyData from "../../../Global/EmptyData";
  import OrderColumn from "../../../Global/OrderColumn";
  import useProfileActivityLog from "./useProfileActivityLog";
  
  const ProfileActivityLog = () => {
    const {
      isLoading,
      isFetching,
      profileActivityLog,
      showEditModal,
      profileActivityLogState,
      paginationOptions,
      updateProfileActivityLogFields,
      handleEditColumnsClick,
      handlePagination,
      handleClearClick,
      handlePageSize,
      handleSearch,
      handleSort,
      refetch,
      getRow,
    } = useProfileActivityLog();

    return (
      <>
        <div className="col-auto pro-pt-3 pro-pb-6">
          <SearchFilters
            onSearchInput={handleSearch}
            loading={isLoading}
            SearchIcon={
              <span className="material-symbols-outlined"> search </span>
            }
            showClearFilters={profileActivityLogState?.search === "" ? false : true}
            handleClear={handleClearClick}
            searchInputProps={{ value: profileActivityLogState?.search }}
            showActions={true}
            handleActionClick={handleEditColumnsClick}
          />
          {profileActivityLog?.data?.result?.length === 0 ? (
            <EmptyData />
          ) : (
            <Table
              multiSelect={false}
              data={profileActivityLog?.data?.result || []}
              uniqueID={"id"}
              fields={profileActivityLog?.data?.fields || []}
              SortIcon={<FaSort />}
              editIcon={<span className="material-symbols-outlined">edit</span>}
              handleSort={handleSort}
              getRow={getRow}
              loading={isFetching}
              clear={profileActivityLogState?.clearSelection}
              perpage={profileActivityLogState?.currentPageSize}
              assignable={false}
              deletable={false}
              editable={false}
              showCheckBox={false}
            />
          )}
          <ModalLayout
            show={showEditModal}
            handleClose={handleEditColumnsClick}
            backdrop="static"
          >
            <div className="pro-m-5">
              <OrderColumn
                title={"Choose which columns you see"}
                refetchData={refetch}
                tableFields={profileActivityLog?.data?.fields || []}
                moduleId={profileActivityLog?.data?.module_id}
                updateData={updateProfileActivityLogFields}
              />
            </div>
          </ModalLayout>
  
          {profileActivityLog?.data?.result?.length > 0 && (
            <Pagination
              currentPage={profileActivityLogState?.currentPage}
              totalPageCount={Math.ceil(
                profileActivityLog.data.total_count / profileActivityLogState.currentPageSize
              )}
              defaultValue={paginationOptions?.filter(
                (item) => item?.value === profileActivityLogState?.currentPageSize
              )}
              onPageChange={handlePagination}
              options={paginationOptions}
              onActionChange={handlePageSize}
              center
            />
          )}
        </div>
      </>
    );
  };
  
  export default ProfileActivityLog;
  